import { render, staticRenderFns } from "./compose-message-dialog.vue?vue&type=template&id=5706a167&scoped=true&"
import script from "./compose-message-dialog.vue?vue&type=script&lang=js&"
export * from "./compose-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5706a167",
  null
  
)

export default component.exports